export const orderSideColors = {
  buy: 'green',
  sell: 'blue',
};

export const orderSideLabels = {
  buy: 'Buy',
  sell: 'Sell',
};

export const orderTypeColors = {
  lo: 'green',
  mp: 'blue',
  ato: 'cyan',
  atc: 'lime',
};

export const orderStatusColors = {
  1001: 'yellow',
  1002: 'yellow',
  1003: 'green',
  1004: 'grey',
  1005: 'red',
  1006: 'purple',
};

export const stockOrderStatusLabels = {
  1001: 'Đã nhận',
  1002: 'Chờ khớp',
  1003: 'Đã khớp',
  1004: 'Đã huỷ',
  1005: 'Lỗi lệnh',
  1006: 'Khớp 1 phần',
};

export const stockOrderAppStatusLabels = {
  1001: 'Đã nhận',
  1002: 'Chờ khớp',
  1003: 'Đã khớp',
  1004: 'Đã huỷ',
  1005: 'Đang xử lý',
  1006: 'Đã khớp',
};

export const modifyCancelTypeColors = {
  modify: 'blue',
  cancel: 'red',
};

export const modifyCancelTypeLabels = {
  modify: 'Sửa lệnh',
  cancel: 'Huỷ lệnh',
};

export const modifyCancelStatusColors = {
  1001: 'yellow',
  1002: 'yellow',
  1003: 'green',
  1004: 'grey',
  1005: 'red',
};

export const modifyCancelStatusLabels = {
  1001: 'Đã nhận',
  1002: 'Đang xử lý',
  1003: 'Thành công',
  1004: 'Đã huỷ',
  1005: 'Thất bại',
};
